# Dashboard Estratégico de Obras - Componente de Gráfico
# Gerencia gráficos ECharts com diferentes visualizações e tipos (pie/bar)

import * as echarts from 'echarts'
import translations from "../../../translations"
import * as I18n from "../../../services/i18n"

class ObrasDashboardChart
  constructor: ->
    @chart = null
    @chartElement = null
    @currentViewType = 'sub_status'
    @currentChartType = 'bar'
    @currentFilters = {}  # Armazenar filtros atuais

  init: ->
    @chartElement = document.getElementById('strategic-status-chart')
    if @chartElement
      @chart = echarts.init(@chartElement)
      @setupResponsive()
      @bindTabEvents()
      @bindChartTypeEvents()

    console.log('Switching view to:', @currentViewType)

  bindTabEvents: ->
    $('#tab-entity-status').on 'click', (e) =>
      e.preventDefault()
      @switchView('entity_status')

    $('#tab-sub-status').on 'click', (e) =>
      e.preventDefault()
      @switchView('sub_status')

    $('#tab-by-entity').on 'click', (e) =>
      e.preventDefault()
      @switchView('by_entity')

  bindChartTypeEvents: ->
    $('#pie-chart-btn').on 'click', (e) =>
      e.preventDefault()
      @switchChartType('pie')

    $('#bar-chart-btn').on 'click', (e) =>
      e.preventDefault()
      @switchChartType('bar')

  switchChartType: (chartType) ->
    return if @currentChartType == chartType

    @currentChartType = chartType
    @updateChartTypeButtons(chartType)
    @loadData(@currentFilters)  # Usar filtros atuais

  updateChartTypeButtons: (chartType) ->
    $('.chart-type-toggle .btn').removeClass('active')
    if chartType == 'pie'
      $('#pie-chart-btn').addClass('active')
    else
      $('#bar-chart-btn').addClass('active')

  switchView: (viewType) ->
    console.log('Switching view to:', viewType)
    return if @currentViewType == viewType

    @currentViewType = viewType
    @updateActiveTab(viewType)
    @updateChartTitle(viewType)
    @loadData(@currentFilters)  # Usar filtros atuais

  updateActiveTab: (viewType) ->
    $('.nav-tabs .nav-link').removeClass('active')
    $("[data-view='#{viewType}']").addClass('active')

  updateChartTitle: (viewType) ->

    console.log('Switching view to:', viewType)
    titleKey = switch viewType
      when 'strategic_status' then 'obras_dashboard_estrategico.index.chart.general_view'
      when 'entity_status' then 'obras_dashboard_estrategico.index.chart.by_status'
      when 'sub_status' then 'obras_dashboard_estrategico.index.chart.by_sub_status'
      when 'by_entity' then 'obras_dashboard_estrategico.index.chart.by_entity'
      else 'obras_dashboard_estrategico.index.chart.general_view'
    
    # Try to get translation, otherwise fallback to Portuguese
    try
      title = I18n.t(translations(), titleKey)
      if title == '' or not title?
        throw new Error("Translation not found")
    catch
      title = switch viewType
        when 'strategic_status' then 'Visão Geral das Obras'
        when 'entity_status' then 'Obras por Estados Agrupados'
        when 'sub_status' then 'Obras por Estado'
        when 'by_entity' then 'Obras por Entidade'
        else 'Visão Geral das Obras'
    
    $('#chart-title').text(title)

  loadData: (filters = {}) ->
    return unless @chart

    @showChartLoading()

    console.log @currentViewType

    # Para a visão geral, usar sub_status ao invés de strategic_status
    viewType = if @currentViewType == 'strategic_status' then 'sub_status' else @currentViewType

    console.log('Loading data for view:', viewType)
    
    # Combinar parâmetros de visualização com filtros da tabela
    params = $.extend({}, filters, { view_type: viewType })

    $.ajax
      url: '/dashboard_estrategico/chart_data'
      method: 'GET'
      data: params
      success: (response) =>
        @hideChartLoading()
        @renderChart(response.data || [])

        # in #amount set response.additional_data if available

        if response.additional_value
          $('#amount').text(response.additional_value || '0')
          $('#amount').show()
        else
          $('#amount').hide()

      error: (xhr, status, error) =>
        @hideChartLoading()
        console.error 'Erro ao carregar dados do gráfico:', error, xhr.responseText
        @showChartError()

  renderChart: (data) ->
    return unless @chart

    option = if @currentChartType == 'pie'
      @buildPieChartOption(data)
    else
      @buildBarChartOption(data)
    
    @chart.setOption(option, true)
    
    # Mostrar legenda personalizada apenas na visão geral
    if @currentViewType == 'strategic_status'
      @buildCustomLegend(data)
    else
      @hideCustomLegend()

  buildPieChartOption: (data) ->
    {
      tooltip: {
        trigger: 'item'
        formatter: '{a} <br/>{b}: {c} ({d}%)'
      }
      legend: {
        orient: 'vertical'
        left: 10
        top: 20
        bottom: 20
        type: 'scroll'
        textStyle: {
          fontSize: 12
        }
      }
      series: [{
        name: @getSeriesName()
        type: 'pie'
        radius: ['40%', '70%']
        center: ['60%', '50%']
        avoidLabelOverlap: false
        label: {
          show: false
          position: 'center'
        }
        emphasis: {
          label: {
            show: true
            fontSize: '16'
            fontWeight: 'bold'
          }
        }
        labelLine: {
          show: false
        }
        data: data.map((item) => {
          name: item.name
          value: item.value
          itemStyle: {
            color: item.color
          }
        })
      }]
    }

  buildBarChartOption: (data) ->
    categories = data.map (item) -> item.name
    values = data.map (item) -> item.value
    colors = data.map (item) -> item.color

    dataLabel = @getDataLabel()
    
    axisLabelRotate = 0
    axisLabelFontSize = if @currentViewType in ['sub_status', 'by_entity'] then 10 else 12
    
    {
      tooltip: {
        trigger: 'axis'
        axisPointer: {
          type: 'shadow'
        }
        formatter: (params) ->
          item = params[0]
          tooltip = data[item.dataIndex]?.tooltip || item.name
          "#{tooltip}<br/>#{dataLabel}: <b>#{item.value}</b>"
      }
      grid: {
        left: '1%'
        right: '1%'
        bottom: '8%'
        containLabel: true
        top: '6%'
      }
      xAxis: {
        type: 'category'
        data: categories
        axisLabel: {
          rotate: axisLabelRotate
          fontSize: axisLabelFontSize
          interval: 0
          # impar top 0 par to 20

          rich: {
            impar: {
              padding: [3, 0, 0, 0]
            },
            par: {
              padding: [25, 0, 0, 0]
            }
          }
          formatter: (value, index) ->
            impar = (index + 1) % 2 == 1
            variant = if impar then 'impar' else 'par'
            # Só aplica truncamento quando há muitas categorias
            if categories.length <= 4
              value  # Não trunca para 4 ou menos barras
            else
              maxLength = if categories.length > 20 then 20 else if categories.length > 15 then 25 else if categories.length > 6 then 30 else 35
              if value.length > maxLength + 2
                value = value.substring(0, maxLength) + '...'
              else
                value

            return "{#{variant}|#{value}}"
        }
        axisTick: {
          alignWithLabel: true
        }
      }
      yAxis: {
        type: 'value'
        nameGap: 50
        minInterval: 1,
        min: 0,
        max: if values.length < 100 then 100 else values.length,
        splitLine: {
          show: false
        }
      }
      series: [{
        name: dataLabel
        type: 'bar'
        data: values.map (value, index) -> {
          value: value
          itemStyle: {
            color: colors[index] || '#3498db'
            borderRadius: [5, 5, 0, 0]
          }
        }
       
        showBackground: true
        backgroundStyle: {
          color: 'rgba(180, 180, 180, 0.2)'
          borderRadius: [7.5, 7.5, 0, 0]
        }
        barWidth: 40
      }]
    }

  getSeriesName: ->
    switch @currentViewType
      when 'strategic_status' then 'Obras por Status'  # Visão geral agora mostra sub-status
      when 'entity_status' then 'Obras por Status'
      when 'sub_status' then 'Obras por Sub-Status'
      when 'by_entity' then 'Obras por Entidade'
      else 'Obras'

  getDataLabel: ->
    I18n.t(translations(), 'obras_dashboard_estrategico.index.obras') or 'Obras/Projetos'

  getYAxisName: ->
    'Quantidade de Obras'  # Sempre obras agora

  setupResponsive: ->
    return unless @chart
    
    window.addEventListener 'resize', =>
      @chart.resize()

  showChartLoading: ->
    return unless @chart
    @chart.showLoading('default', {
      text: 'Carregando...'
      color: '#007bff'
      textColor: '#000'
      maskColor: 'rgba(255, 255, 255, 0.8)'
    })

  hideChartLoading: ->
    return unless @chart
    @chart.hideLoading()

  showChartError: ->
    return unless @chart
    
    errorOption = {
      title: {
        text: 'Erro ao carregar dados'
        left: 'center'
        top: 'middle'
        textStyle: {
          color: '#999'
          fontSize: 16
        }
      }
    }
    @chart.setOption(errorOption, true)

  destroy: ->
    if @chart
      @chart.dispose()
      @chart = null

  # Constrói legenda personalizada para visão geral
  buildCustomLegend: (data) ->
    # Extrair strategic_status únicos com suas cores
    parentStatuses = {}
    
    data.forEach (item) ->
      # O nome vem como "Parent Status - Status"
      parts = item.name.split(' - ')
      if parts.length >= 2
        parentName = parts[0]
        parentStatuses[parentName] = item.color
    
    # Construir HTML da legenda
    legendHtml = ''
    for parentName, color of parentStatuses
      legendHtml += """
        <div class="legend-item">
          <span class="legend-color" style="background-color: #{color};"></span>
          <span class="legend-text">#{parentName}</span>
        </div>
      """
    
    # Inserir no DOM
    $('.legend-items').html(legendHtml)
    $('#chart-custom-legend').show()

  # Oculta legenda personalizada
  hideCustomLegend: ->
    $('#chart-custom-legend').hide()

  # Método público para atualizar gráfico com filtros da tabela
  updateWithFilters: (filters) ->
    @currentFilters = filters || {}  # Armazenar filtros
    @loadData(@currentFilters)

# Exportar a classe
window.ObrasDashboardChart = ObrasDashboardChart 